"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var react_northstar_1 = require("@fluentui/react-northstar");
var Pie_1 = require("../../chart/Charts/Pie");
require("./visao-geral-atendimentos-status.scss");
var react_i18next_1 = require("react-i18next");
var VisaoGeralAtendimentosPorStatus = /** @class */ (function (_super) {
    __extends(VisaoGeralAtendimentosPorStatus, _super);
    function VisaoGeralAtendimentosPorStatus(props) {
        var _this = _super.call(this, props) || this;
        _this.parseMetrics = function (metricsData) {
            return {
                atendimentosRealizados: Math.round((metricsData === null || metricsData === void 0 ? void 0 : metricsData.percentRealizados) * 100),
                atendimentosCancelados: Math.round((metricsData === null || metricsData === void 0 ? void 0 : metricsData.percentExpiradosCancelados) * 100),
                atendimentosAguardando: Math.round((metricsData === null || metricsData === void 0 ? void 0 : metricsData.percentAguardandoAtendimento) * 100),
            };
        };
        _this.localize = _this.props.t;
        _this.state = {
            activeTabId: 0,
            metrics: _this.props.metrics,
            chartData: {
                labels: ["" + _this.localize("AtendimentosRealizados"), "" + _this.localize("AtendimentosExpirados"), "" + _this.localize("AguardandoAtendimento")],
                datasets: [
                    {
                        data: [
                            _this.parseMetrics(_this.props.metrics).atendimentosRealizados,
                            _this.parseMetrics(_this.props.metrics).atendimentosCancelados,
                            _this.parseMetrics(_this.props.metrics).atendimentosAguardando
                        ],
                    },
                ],
            },
        };
        return _this;
    }
    VisaoGeralAtendimentosPorStatus.prototype.componentDidMount = function () {
        microsoftTeams.initialize();
    };
    VisaoGeralAtendimentosPorStatus.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.metrics !== this.props.metrics) {
            this.setState({
                activeTabId: this.props.index,
                chartData: {
                    labels: ["" + this.localize("AtendimentosRealizados"), "" + this.localize("AtendimentosExpirados"), "" + this.localize("AguardandoAtendimento")],
                    datasets: [
                        {
                            data: [
                                this.parseMetrics(this.props.metrics).atendimentosRealizados,
                                this.parseMetrics(this.props.metrics).atendimentosCancelados,
                                this.parseMetrics(this.props.metrics).atendimentosAguardando
                            ],
                        },
                    ],
                }
            });
        }
    };
    VisaoGeralAtendimentosPorStatus.prototype.formatDataNumber = function (number) {
        if (number)
            return new Intl.NumberFormat('pt-BR').format(number);
        else
            return 0;
    };
    VisaoGeralAtendimentosPorStatus.prototype.setActiveTabId = function (index, item) {
        var selected = isNaN(item.content.split(" ")[0]) ? 0 : parseInt(item.content.split(" ")[0]);
        this.props.filter(selected, index);
        this.setState({
            activeTabId: index
        });
    };
    VisaoGeralAtendimentosPorStatus.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var noData = false;
        if (((_a = this.props.metrics) === null || _a === void 0 ? void 0 : _a.percentRealizados) == 0 &&
            ((_b = this.props.metrics) === null || _b === void 0 ? void 0 : _b.percentExpiradosCancelados) == 0 &&
            ((_c = this.props.metrics) === null || _c === void 0 ? void 0 : _c.percentAguardandoAtendimento) == 0) {
            noData = true;
        }
        return (React.createElement(react_northstar_1.Box, { className: "visao-geral-atendimentos", styles: {
                display: "grid",
                gridGap: "1.2rem",
                gridTemplate: "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(37.75rem, 1fr))",
                gridAutoFlow: "dense",
                gridAutoRows: "27rem 2rem",
                padding: "1rem 2rem",
                minWidth: "20rem",
                "@media (max-width: 986px)": {
                    gridTemplate: "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                },
            } },
            React.createElement(react_northstar_1.Card.Header, null,
                React.createElement(react_northstar_1.Flex, { gap: "gap.small", space: "between", style: { minHeight: "2rem" } },
                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", column: true },
                        React.createElement(react_northstar_1.Text, { content: this.localize("VisaoGeralAtendimentos"), style: { margin: 0 }, weight: "bold" })))),
            React.createElement(react_northstar_1.Card.Body, { style: {
                    marginBottom: "0.75rem",
                    height: "100%",
                    overflow: "hidden",
                }, fitted: true }, this.props.metrics ?
                React.createElement(React.Fragment, null,
                    React.createElement(react_northstar_1.Menu, { className: "tabList", style: {
                            border: "none",
                            background: "none",
                            marginBottom: "3.5rem",
                        }, items: [
                            {
                                key: "1",
                                content: this.localize("TabHoje")
                            },
                            {
                                key: "7",
                                content: this.localize("7dias")
                            },
                            {
                                key: "30",
                                content: this.localize("30dias")
                            },
                            {
                                key: "60",
                                content: this.localize("60dias")
                            }
                        ], activeIndex: this.props.index, onItemClick: function (currentTarget, props) {
                            return _this.setActiveTabId(props && props.index ? props.index : 0, props);
                        }, accessibility: react_northstar_1.tabListBehavior, underlined: true, primary: true }),
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium", className: "chartVisaoGeral" },
                        React.createElement(react_northstar_1.Flex, { styles: {
                                width: "50%",
                                height: "5.5rem",
                            } },
                            noData &&
                                React.createElement(react_northstar_1.Flex, { column: true },
                                    React.createElement(react_northstar_1.Flex, { vAlign: "center", hAlign: "center" },
                                        React.createElement("svg", { viewBox: "0 0 64 64", className: "emptyPie" },
                                            React.createElement("circle", { r: "25%", cx: "50%", cy: "50%", style: { strokeDasharray: "75.3 100" } }),
                                            React.createElement("circle", { r: "25%", cx: "50%", cy: "50%", style: { strokeDasharray: "19.9 100", stroke: "#D1D2D4", strokeDashoffset: "-75.3", animationDelay: "0.25s" } }))),
                                    React.createElement(react_northstar_1.Flex, { vAlign: "center", hAlign: "center", styles: { padding: "2rem 4rem" } },
                                        React.createElement(react_northstar_1.Text, { size: "smaller", weight: "bold", content: this.localize("NaoExistemAtendimentos"), styles: { color: "rgb(138, 138, 138)" } }))),
                            !noData &&
                                React.createElement(react_northstar_1.ProviderConsumer, { render: function (globalTheme) {
                                        return (React.createElement(Pie_1.default, __assign({}, {
                                            title: _this.localize("VisaoGeralAtendimentos"),
                                            data: _this.state.chartData,
                                            siteVariables: globalTheme.siteVariables,
                                        })));
                                    } })),
                        React.createElement(react_northstar_1.Flex, { className: "chartLabels", gap: "gap.small", styles: {
                                width: "50%",
                                height: "5.5rem",
                            }, column: true },
                            React.createElement(react_northstar_1.Flex, null,
                                React.createElement(react_northstar_1.Box, { styles: { backgroundColor: "#6264A7", width: ".5rem", height: "4rem", marginRight: "1.5rem", marginTop: ".5rem" } }),
                                React.createElement(react_northstar_1.Flex, { column: true },
                                    React.createElement(react_northstar_1.Text, { size: "larger", content: ((_d = this.parseMetrics(this.props.metrics)) === null || _d === void 0 ? void 0 : _d.atendimentosRealizados) + "%" }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", weight: "bold", content: this.localize("AtendimentosRealizados") }))),
                            React.createElement(react_northstar_1.Flex, null,
                                React.createElement(react_northstar_1.Box, { styles: { backgroundColor: "#C4314B", width: ".5rem", height: "4rem", marginRight: "1.5rem", marginTop: ".5rem" } }),
                                React.createElement(react_northstar_1.Flex, { column: true },
                                    React.createElement(react_northstar_1.Text, { size: "larger", content: ((_e = this.parseMetrics(this.props.metrics)) === null || _e === void 0 ? void 0 : _e.atendimentosCancelados) + "%" }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", weight: "bold", content: this.localize("AtendimentosExpirados") }))),
                            React.createElement(react_northstar_1.Flex, null,
                                React.createElement(react_northstar_1.Box, { styles: { backgroundColor: "#B3B0AD", width: ".5rem", height: "4rem", marginRight: "1.5rem", marginTop: ".5rem" } }),
                                React.createElement(react_northstar_1.Flex, { column: true },
                                    React.createElement(react_northstar_1.Text, { size: "larger", content: ((_f = this.parseMetrics(this.props.metrics)) === null || _f === void 0 ? void 0 : _f.atendimentosAguardando) + "%" }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", weight: "bold", content: this.localize("AguardandoAtendimento") }))))))
                :
                    React.createElement("svg", { className: "emptyChart", viewBox: "0 0 550 550" },
                        React.createElement("rect", { y: "37.7", width: "88.7", height: "414.6" }),
                        React.createElement("rect", { x: "133.8", y: "147.4", width: "88.7", height: "304.9" }),
                        React.createElement("rect", { x: "267.6", y: "235.7", width: "88.7", height: "216.6" }),
                        React.createElement("rect", { x: "401.3", y: "307.2", width: "88.7", height: "145.1" })))));
    };
    return VisaoGeralAtendimentosPorStatus;
}(React.Component));
var visaoGeralAtendimentosWithTranslation = react_i18next_1.withTranslation()(VisaoGeralAtendimentosPorStatus);
exports.default = visaoGeralAtendimentosWithTranslation;
//# sourceMappingURL=visao-geral-atendimentos-status.js.map